export const MINIMUM_PURCHASE_AMT = 10;
export const ZERO_BALANCE = 0;
// TODO these are temporary default amounts until we get more data.  It will probably change to depend on account level.
export const DEFAULT_AUTO_FUND_AMTS = [50, 100, 250, 500];
export const DEFAULT_FUND_AMTS = [25, 50, 100, 250];
export const ALL_FUND_AMTS = [...DEFAULT_FUND_AMTS, 500, 750, 1000, 2000, 3000, 4000, 5000];

export const DEFAULT_THRESHOLD = 10;
export const DEFAULT_AUTO_FUND_AMOUNT = 100;
export const DEFAULT_CUTOFF = 2;
export const DEFAULT_PURCHASE_AMOUNT = 25;
